import PropTypes from 'prop-types'
import { Button, Tooltip } from 'antd'
import { useIntl } from 'react-intl'

/**
 * Starts federated sign-in through one identity provider. Shows the logo
 * uploaded for that provider in Administration, or its label when there is
 * none; the full "Sign in with" wording is the tooltip and accessible name.
 */
const ProviderButton = ({ provider, busy, loading, onSelect }) => {
  const intl = useIntl()
  const action = intl.formatMessage({ id: 'auth.signInWithProvider' }, { provider: provider.label })

  return (
    <Tooltip title={action}>
      <Button
        block
        size="large"
        className="login-provider-button"
        aria-label={action}
        data-testid="provider-button"
        data-provider={provider.name}
        disabled={busy && !loading}
        loading={loading}
        onClick={() => onSelect(provider.name)}
      >
        {provider.logo_url ? (
          <img src={provider.logo_url} alt="" className="login-provider-logo" data-testid="provider-logo" />
        ) : (
          provider.label
        )}
      </Button>
    </Tooltip>
  )
}

ProviderButton.propTypes = {
  provider: PropTypes.shape({ name: PropTypes.string, label: PropTypes.string, logo_url: PropTypes.string })
    .isRequired,
  busy: PropTypes.bool,
  loading: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
}

export default ProviderButton
